// extracted by mini-css-extract-plugin
export var deleteModal = "_fg-0";